import React, { useState } from "react";
import { IUserLogin } from "../interfaces/User";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../services/apiService";
import { IAppState } from "../interfaces/App";
import type { AppDispatch } from "../stores/AppStore";

function Register() {
    const app: IAppState = useSelector((appState: any) => appState.app);
    const initialState: IUserLogin = {user: app.user.email, passwd: "", confirm: ""};
    const [state, setState] = useState(initialState);
    const dispatch = useDispatch<AppDispatch>();
    const handleSubmit = (ev: any) => {
        ev.preventDefault();
        dispatch(register(state)).unwrap().then((res: any) => {
            console.log("register:", res);
        })
    };
    return (
        <div className="home">
            <div className="intro">
                <form onSubmit={(ev: any) => handleSubmit(ev)} >
                    <input value={state.user} autoComplete={"off"} placeholder="Login" onChange={(ev) => setState({...state, user: ev.currentTarget.value})} />
                    <input type="password" placeholder="Kennwort" value={state.passwd} onChange={(ev) => setState({...state, passwd: ev.currentTarget.value})} />
                    <input type="password" value={state.confirm} onChange={(ev) => setState({...state, confirm: ev.currentTarget.value})} />
                    <br/>
                    <input type="submit" value="Ok"/>
                </form>
            </div>
        </div>
    );
}

export default (Register);

